import styled, {css} from 'styled-components'

type StyledInputStatusIconProps = {
    $hasError?: boolean
}
export const InputStatusIconWrapper = styled.div<StyledInputStatusIconProps>`
    ${({$hasError, theme: {palette}}) => css`
        display: flex;
        color: ${$hasError ? palette.danger['700'] : palette.success['700']};
    `}
`
